import { useCallback } from 'react';
import { useRouter } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A custom hook to handle navigation from the customization screen.
 */
export const useCustomizationNavigation = (_params: Params) => {
  const router = useRouter();

  // ─── Helpers ───────────────────────────────────────────────────────────────

  const navigateToPreviousScreen = useCallback(() => {
    router.back();
  }, [router]);

  // ───────────────────────────────────────────────────────────────────────────

  return {
    navigateToPreviousScreen,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  restaurantSlug: string | undefined;
  addressId: string | undefined;
};
